<template>
  <div class="scb_container text-normal text-left">
    <div class="f-column">
      <div class="weight_500 uppercase mx-4">
        {{ $t(`browse.filter_categories.hands`) }}
      </div>

      <div class="mx-4 mt-2 mb-2">
        <div
          class="category_chart"
          @mouseleave="setHiglight(null), (handHighlight = -1)"
        >
          <div
            v-for="(category, i) in handCategories"
            :key="i"
            class="category_chart_item"
            :class="{
              category_chart_item_inactive: handHighlightChart !== -1 && handHighlightChart !== i,
            }"
            :style="`width: ${category.atOccurence * 100}%;
             background:${category.clr} `"
            @mouseenter="setHiglight(category), (handHighlight = i)"
          />
        </div>
      </div>

      <div @mouseleave="setHiglight(null), (handHighlightChart = -1)">
        <div
          v-for="(category, i) in handCategories"
          :key="i"
          class="sbc_item gw_btn_hover_back"
          :class="{ gw_btn_hover_back_active: handHighlight === i }"
          @mouseenter="setHiglight(category), (handHighlightChart = i)"
        >
          <div class="text-nowrap d-flex">
            <div
              style="min-width: 11ch; max-width: 11ch"
              class="truncate"
              :title="$t(`browse.filter_rules.${category.name}`)"
            >
              {{ $t(`browse.filter_rules.${category.name}`) }}
            </div>
            <div
              class="ml-2 text-right"
              style="min-width: 3.5rem"
            >
              {{ numFixed(category.atOccurence * 100, 1) }}%
            </div>
          </div>
          <div class="graph-horizontal ml-2">
            <div
              class="graph-horizontal_item"
              :style="`width: ${category.atOccurenceScaled * 100}%;
             background:${category.clr}`"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="f-column">
      <div class="weight_500 uppercase mx-4">
        {{ $t(`browse.filter_categories.draws`) }}
      </div>

      <div class="mx-4 mt-2 mb-2">
        <div
          class="category_chart"
          @mouseleave="setHiglight(null), (drawHighlight = -1)"
        >
          <div
            v-for="(category, i) in drawCategories"
            :key="i"
            class="category_chart_item"
            :class="{
              category_chart_item_inactive: drawHighlightChart !== -1 && drawHighlightChart !== i,
            }"
            :style="`width: ${category.atOccurence * 100}%;
             background:${category.clr} `"
            @mouseenter="setHiglight(category), (drawHighlight = i)"
          />
        </div>
      </div>

      <div @mouseleave="setHiglight(null), (handHighlightChart = -1)">
        <div
          v-for="(category, i) in drawCategories"
          :key="i"
          class="sbc_item gw_btn_hover_back"
          :class="{ gw_btn_hover_back_active: drawHighlight === i }"
          @mouseenter="setHiglight(category), (drawHighlightChart = i)"
        >
          <div class="text-nowrap d-flex">
            <div
              style="min-width: 11ch; max-width: 11ch"
              class="truncate"
              :title="$t(`browse.filter_rules.${category.name}`)"
            >
              {{ $t(`browse.filter_rules.${category.name}`) }}
            </div>
            <div
              class="ml-2 text-right"
              style="min-width: 3.5rem"
            >
              {{ numFixed(category.atOccurence * 100, 1) }}%
            </div>
          </div>
          <div class="graph-horizontal ml-2">
            <div
              class="graph-horizontal_item"
              :style="`width: ${category.atOccurenceScaled * 100}%;
             background:${category.clr}`"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import { getPercentageOfMax } from '@/helpers/helpers'
import { throttle } from 'lodash'

export default {
  name: 'StudyComboBreakdown',
  mixins: [format_mix],
  props: {
    action: Object,
    catDraws: Array,
    catHands: Array,
  },
  data() {
    return {
      handHighlight: -1,
      drawHighlight: -1,
      handHighlightChart: -1,
      drawHighlightChart: -1,
    }
  },
  methods: {
    setHiglight: throttle(function (cat) {
      if (this.mobile) return
      this.$store.dispatch('sol_detail_highlight', cat)
    }, 40),
    getCategoriesByAction({ categories, allActionCategories }) {
      const actionCategories = (allActionCategories || []).filter(
        i => (i.total_occurrence || i.total_frequency) > 0.001,
      )
      // let actionCategories = allActionCategories || []
      let res = actionCategories.map(i => {
        const category = categories.find(c => c.name === i.name)
        const r = {
          ...i,
          ...category,
          // total_occurrence grouped value
          // total_frequency ungrouped value
          atOccurence: i.total_occurrence || i.total_frequency,
        }
        return r
      })

      const occurences = res.map(c => c.atOccurence)
      const max = Math.max(...occurences)

      res = res.map(c => ({
        ...c,
        atOccurenceScaled: getPercentageOfMax({
          max,
          value: c.atOccurence,
        }),
      }))
      res = res.sort((a, b) => (a.display_order > b.display_order ? 1 : -1))
      return res
    },
  },
  computed: {
    handCategories() {
      const heroIndex = 0
      const res = this.getCategoriesByAction({
        categories: this.catHands.filter(i => i.players[heroIndex].total_occurrence),
        allActionCategories: this.action.hand_categories,
      })
      return res
    },
    drawCategories() {
      const heroIndex = 0
      const res = this.getCategoriesByAction({
        categories: this.catDraws.filter(i => i.players[heroIndex].total_occurrence),
        allActionCategories: this.action.draw_categories,
      })
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.scb_container {
  min-width: 24rem;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.sbc_item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.25rem;
  height: 1.5rem;
  margin: 0 1rem;

  //   &:hover {
  //     background: var(--clr-black-2);
  //   }
}
// .sbc_item_active {
//   background: var(--clr-black-2);
// }
.category_chart {
  display: flex;
  height: 1.5rem;
  // border-radius: 99px;
  border-radius: 6px;
  overflow: hidden;
  &_item {
    // &:first-child {
    //   border-top-left-radius: 99px;
    //   border-bottom-left-radius: 99px;
    // }
    // &:last-child {
    //   border-top-right-radius: 99px;
    //   border-bottom-right-radius: 99px;
    // }
    &_inactive {
      opacity: 0.6;
    }
  }
}
</style>
